import { WebStorageStateStore } from "oidc-client";
import { EnvironmentConfiguration } from "../Config/EnvironmentConfiguration";

class AuthSessionStorage {

    private userStore : WebStorageStateStore;
    private authUrl?: string;
    private clientId?: string;

    constructor() {
    }

    getStorageMedia(){
        return window.sessionStorage;
    }

    getInitUserStore(configuration : EnvironmentConfiguration) {
        this.authUrl = configuration.AbpnIdentity.Authority;
        this.clientId = configuration.AbpnIdentity.ClientId;

        this.userStore = new WebStorageStateStore({ store: this.getStorageMedia() })
        return this.userStore;
    }

    getOidcSession = () => {
        if (!this.userStore) return null;

        const sessionObj = sessionStorage.getItem(`oidc.user:${this.authUrl}:${this.clientId}`);
        if (!sessionObj) return null;

        const oidcStorage = JSON.parse(sessionObj)
        return oidcStorage;
    }

} 

export default new AuthSessionStorage();
